import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';
import { FeatureTogglesResource } from 'angular/resources/feature-toggles.resource';

angular
    .module('app')
    .factory(
        'featureTogglesResource',
        downgradeInjectable(FeatureTogglesResource)
    );
